import { TextH1, TextH2 } from "@/components/Text";
export interface DepositTitleHeaderProps {
	title?: string;
	desc?: string | React.ReactNode;
	descNode?: React.ReactNode;
}
export default function DepositTitleHeader({ title, desc, descNode }: DepositTitleHeaderProps) {
	return (
		<div className="pt-8 px-4">
			<TextH1>{title}</TextH1>

			{desc && <TextH2 className="mt-4 font-semibold">{desc}</TextH2>}
			{descNode && <div className="mt-4">{descNode}</div>}
		</div>
	);
}
